module.exports = __webpack_public_path__ + "img/ปลาซาร์ดีน.b26f7bfd.jpeg";